import { Component, OnInit, Output, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import * as errorUtils from "src/app/modules/utility/global-utils";
import { ImagilityBaseResponse } from '../../../../data/models/response.model';
import { select, Store } from '@ngrx/store';
import { getStepDetails } from '../../store/selectors/sub-task-details.selectors';
import { TaskStep } from 'src/app/data/models/task-step.model';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { updatei140StepStatus, updateStepStatusToInitialState } from '../../store/actions/step-status-update.actions';
import { getStepStatusUpdate } from '../../store/selectors/step-status-update.selectors';
import { loadSubTaskDetails } from '../../store/actions/sub-task-details.actions';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { StepStatusUpdatePayload } from '../../utility/services/stepStatusUpdate.service';
import { GCI140Service } from 'src/app/services/gci140.service';
import { environment } from 'src/environments/environment';
import moment from 'moment';
import { acceptedFileTypes, I140FileUploadConfiguration, PrimaryData} from 'app-models';
import { ActivatedRoute } from '@angular/router';
import { AppServicesLibraryService } from 'app-services-library';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UploadImageDialogComponent } from 'editor-library';
import { EditorComponent } from '@progress/kendo-angular-editor';
import { CustomErrorToastComponent } from 'custom-error-toast';
import { forkJoin, from } from 'rxjs';
import { concatMap, delay, mergeMap, take, takeLast, tap } from 'rxjs/operators';

@Component({
  selector: 'app-print-petition',
  templateUrl: './print-petition.component.html',
  styleUrls: ['./print-petition.component.scss']
})
export class PrintPetitionComponent implements OnInit {

  disabledControls: boolean;
  typeOfButton: string; // This is required for status update button
  stepDetails: TaskStep;
  enableViewDraftButton: boolean;
  draftGeneratedDate: string;
  fullPDFPath: string;
  observableSubscription$ = new Subject();
  primaryData: PrimaryData;
  getCount: number;
  getNewTaskID: string;
  envPath: any;


  
  signatureType: string = '';
  returnForms: string = '';
  courierStatus: number;
  listOfTempDocs: any;
  listDocuments: any;
  displayDialog: boolean = false;
  displayCourier: boolean = false;
  definedtemplate: FormGroup;
  courierStatusForm: FormGroup;
  signatureInfo = [];
  selectedSignatory = [];
  isMailSent: boolean = false;
  signatureChecked: boolean = false;

  additionalCoversForm: FormGroup;  // Declare FormGroup
  signatoriesSignedForm: FormGroup;

  masterSelected:boolean;
  checkedList:any = [];
  
  displayForms: any[];
  templateList=[];
  selectedCourierArr: any[];
  displayedColumns: string[] = ['formType', 'docUploaded', 'actions'];
  dataSource = [];
  signatureTypeList: any[];
  isMenuVisible: boolean = false;
  currentItem = null;
  dependentFormInfo: any = {};
  individualForm: any[];
  
  formsList: any[];
  selectable = true;
  removable = true;
  emailPattern: string = '^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6})(\\s*,\\s*[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6})*$';

  @ViewChild("createtemplatelibraryheaderupload") public createtemplatelibraryheaderupload: UploadImageDialogComponent;

  @Output() @ViewChild("createtemplatelibraryheaderkendoeditor") public createtemplatelibraryheaderkendoeditor: EditorComponent;

  configurations: I140FileUploadConfiguration;
  acceptedTypes = acceptedFileTypes;
  maxfileSizeInMB: number = 10;
  uploadCount = 0;
  selectedDocumentId: any;
  signatureDetailId: any;
  gcPDFSrc: string;
  signatureInfoAvailable: boolean = false;
  currentSelect: boolean = false;
  currentSignature: any;
  placeholderErrorDialog:Boolean = false;
  showNext: boolean = false;
  showPrev: boolean = false;
  
  constructor(private store: Store<any>,
              private toastr: ToastrService,
              private gcI140Service: GCI140Service,
              public dynamicDialogRef: DynamicDialogRef,
              public dynamicDialogConfig: DynamicDialogConfig,
              private stepStatusUpdatePayloadCostruction: StepStatusUpdatePayload,
              private route: ActivatedRoute,
              private appServicesLibraryService: AppServicesLibraryService,
              public fb: FormBuilder
              ) {
    this.masterSelected = false;
    this.draftGeneratedDate = '';
    this.fullPDFPath = '';
    this.disabledControls = false;
    this.primaryData = this.dynamicDialogConfig.data;
    this.showNext = this.primaryData?.showNext; 
    this.showPrev = this.primaryData?.showPrev;
  }

  ngOnInit(): void {
    sessionStorage.setItem('signatureUpload', 'true');
    this.envPath = environment.docs;

    document.addEventListener('click', this.onDocumentClick.bind(this));
    this.getSignatureTypeList();
    // this.getDocumentDetailsList();
    this.onLoadSignature();
    this.getTemplateList();
    this.courierStatusForm = this.fb.group({
      courierStatus: [null, Validators.required],
    })
    this.initdefinedTemplateform();
    this.definedtemplate.controls['addForms'].setValue([1,2]);
    this.onChangeSignature('Signature1');
    // this.getDependentFormInfo();

    // Selector for step status update
    this.store.pipe(select(getStepStatusUpdate)).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
      if (response && response.status === 200) {
        this.toastr.success(response.message, 'Success');
        this.store.dispatch(loadSubTaskDetails({ taskId: this.stepDetails.taskId }));
      }
    });
    this.store.pipe(select(getStepDetails, { id: this.dynamicDialogConfig.data.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data: TaskStep) => {
      this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
      this.stepDetails = data;
      // if (this.stepDetails.stepStatusDetails.stepStatusCode === 'NEW') {
      //   this.updateStepStatus('INPROGRESS');
      // }
      this.toggleControlsStatus();
      this.getGenernatedPetition(false);
    });
  }

  onDocumentClick(): void {
    this.isMenuVisible = false; // Hide the menu
    this.currentItem = null; // Reset the current item
  }

  getSignatureTypeList(){
    this.gcI140Service.getSignatureTypeList('SIGNTYP').subscribe(data => {
      if(data){
        this.signatureTypeList = data?.data;
        this.signatureTypeList.map(x=>{
          x.signatureType = x.code;
          x.id = x.code == "IMAGE" ? 'Signature1' : 'Signature2';
        })
      }
    });
  }

  generatePetition(isDraft: boolean = false) {
    this.gcI140Service.postReviewPetitiondocDraft(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, isDraft).subscribe((response: ImagilityBaseResponse) => {
      if (response && response.data) {
        this.enableViewDraftButton = response.data.isExist;
        this.draftGeneratedDate = response.data.lastModifiedTime;
        this.fullPDFPath = response.data.path;
        this.toastr.success(response.message, 'Success');
      }
    });
  }

  getGenernatedPetition(isDraft: boolean = false) {
    this.gcI140Service.getReviewPetitiondocDraft(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, isDraft).subscribe((response: ImagilityBaseResponse) => {
      if (response && response.status === 200) {
        this.enableViewDraftButton = response.data.isExist;
        this.draftGeneratedDate = response.data.lastModifiedTime;
        this.fullPDFPath = response.data.path;
      }
    });
  }

  updateStepStatus(status) {
    this.store.dispatch(updatei140StepStatus({ payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status), subTaskId: this.stepDetails.taskId, actionCode: this.stepDetails.stepActionList[0].layoutCode }));
  }

  viewPetition(fullPDFPath) {
    window.open(`${environment.docs}${fullPDFPath.substring(23)}`);
  }



  //Toggle controls status based on step status
  toggleControlsStatus() {
    this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
    // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  handleClose() {
    this.dynamicDialogRef.close();
  }

  ngOnDestroy() {
    sessionStorage.removeItem('signatureUpload');
    document.removeEventListener('click', this.onDocumentClick.bind(this));
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    // Update the Step Status state to empty state
    this.store.dispatch(updateStepStatusToInitialState());
  }


  getTemplateList(){
      const payload = {
        "superTaskTypeId": "EMALTEMPLT",
        "isDefault": "false",
        "pageNumber": 1,
        "recordsPerPage": 100,
        "searchText": ""
      }
      this.gcI140Service.getEmailTemplateList(payload).subscribe(data => {
        data['documentTemplate'].forEach(element => {
          element.documentType = element.documentType.code;
          element.templateType = element.templateType.code;
          this.templateList.push(element);
        });
      });
    }

     getDocumentDetails() {
        this.gcI140Service.getDocumentDetails(this.primaryData.stepId).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
          this.isMailSent = response.data?.signatureDetailId ? true : false;
          if (response && response.data && response.data.signatureDocumentDTOList.length > 0) 
            {
              this.signatureDetailId = response.data.signatureDetailId;
              this.listDocuments = response.data.signatureDocumentDTOList;
              this.listDocuments.map(item=>{
                let signatureList = [];
                item.isSelected = false;
                if(item?.signatories){
                  item?.signatories.forEach(element => {
                    if(element.checked){
                      if(item.signatories.length==1){
                        signatureList.push(element.label)
                      } else if(item.signatories[item.signatories.length-1]){
                        signatureList.push(element.label)
                      } else {
                        signatureList.push(element.label+',')
                      }
                    }
                  });
                  item.signatorList = signatureList;
                }
              });
            } else {
              this.listDocuments = [];
            }
        });
      }
  
      onTemplateChange(event){
        this.gcI140Service.getEmailTemplateByIdBenId(event,this.primaryData.subTaskId).subscribe(data=>{
     
          if(data){
            this.definedtemplate.controls['emailbody'].setValue(data.contentMap.body+ '<br>' +  data.contentMap?.footer);
            this.definedtemplate.controls['subject'].setValue(data.contentMap.header);
          }
    
          var split  = this.definedtemplate.controls['emailbody'].value.split("<p>");
         
          for(var i=0; i<split.length; i++){
            if(split[i].includes('${')){
              split[i] = "<p style='color:red'>"+split[i];
            }
            else{
              split[i] = "<p>"+split[i];
            }
          }
          this.definedtemplate.controls['emailbody'].setValue(split.join(''));
    
        })
      }
    
  

  
    onChangeSignature(type) {
      this.signatureType = type;
      this.onLoadSignature();
      this.checkedList = [];
      this.formsList = [];
      this.displayForms = [];
      this.definedtemplate.reset(); 
      this.initdefinedTemplateform();
      if(!type){
        this.onReturnForms(null);
      } else {
        this.onReturnForms('type3');
      }
    }
    
     onLoadSignature(): void {
        this.gcI140Service.getsignatureDetails(this.primaryData.subTaskId)
          .pipe(takeUntil(this.observableSubscription$))
          .subscribe((response: any) => {
            if (response?.data) {
              this.signatureInfo = response.data;
              this.selectedSignatory = response.data;
              if(this.signatureInfo.find(item => item.signatureAvalible === true)){
                this.signatureInfoAvailable = true;
              } 
       
              // Create form controls for `additionalCoversForm`
              const additionalCoversControls = this.signatureInfo.reduce((controls, cover, index) => {
                controls[index] = new FormControl(cover.checked); // Default value for each checkbox
                return controls;
              }, {});
      
              this.additionalCoversForm = this.fb.group(additionalCoversControls);
      
              // Create form controls for `signatoriesSignedForm`
              const signatoriesControls = this.selectedSignatory.reduce((controls, cover, index) => {
                controls[index] = new FormControl(cover.checked); // Default value for each checkbox
                return controls;
              }, {});
      
              this.signatoriesSignedForm = this.fb.group(signatoriesControls);
            }
          });
      }
      
    
      onReturnForms(type) { 
        this.masterSelected = false;
        if(type=='type3' || type=='type4'){
          this.returnForms = type;
        }
        this.checkedList = [];
        this.formsList = [];
        this.displayForms = [];
        this.definedtemplate.reset();
        this.getDocumentDetails();
        this.initdefinedTemplateform();
      } 
    
      onChangeCourier(type) {
        this.courierStatusForm.controls['courierStatus'].setValue(type);
      } 
    
      checkUncheckAll() {
        for (var i = 0; i < this.listDocuments.length; i++) {
          this.listDocuments[i].isSelected = this.masterSelected;
        }
        this.getCheckedItemList();
      }
      isAllSelected() {
        this.masterSelected = this.listDocuments.every(function(item:any) {
            return item.isSelected == true;
          })
        this.getCheckedItemList();
      }
      
      getCheckedItemList(){
        this.checkedList = [];
        for (var i = 0; i < this.listDocuments.length; i++) {
          if(this.listDocuments[i].isSelected)
          this.checkedList.push(this.listDocuments[i]);
        }
      }
    
      onClickEmail(){
        this.commonMail();
        this.filterItems();
      }
    
      filterItems() {
        const filteredItems = this.checkedList.filter((item) =>
          this.formsList.some((firstItem) => firstItem.pbSupportDocumentId === item.pbSupportDocumentId)
        );
    
        let newArray: any = [];
        newArray = filteredItems.map(item => item.pbSupportDocumentId);
        this.definedtemplate.controls['addForms'].setValue(newArray);
    
        this.displayForms = [];
        this.displayForms = this.checkedList;
      }
    
      commonMail(){
        this.definedtemplate.reset(); 
        this.initdefinedTemplateform();
        this.formsList = this.listDocuments;
        const selectedEmail: any = this.selectedSignatory.filter(item => item.checked && item.mail)
        .map(item => item.mail);
        this.definedtemplate.controls['toEmailids'].setValue(selectedEmail);
        this.definedtemplate.controls['fromEmailids'].setValue(['communication@imagility.co']);
        this.displayDialog = true; 
      }
    
      onIndividualMail(item){
        this.commonMail();
        this.filterIndividualItems(item);
      }
    
      filterIndividualItems(item) {
        const filteredItems = [item].filter((x) =>
          this.formsList.some((firstItem) => firstItem.pbSupportDocumentId === x.pbSupportDocumentId)
        );
    
        let newArray: any = [];
        newArray = filteredItems.map(item => item.pbSupportDocumentId);
        this.definedtemplate.controls['addForms'].setValue(newArray);
    
        this.displayForms = [];
        this.displayForms = [item];
      }
    
      handleNo(){
        this.displayDialog = false;
      }
    
      initdefinedTemplateform() { 
        this.definedtemplate = this.fb.group({
          templatename: [''],
          fromEmailids: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
          toEmailids: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
          ccEmailids: ['', Validators.pattern(this.emailPattern)],
          subject: ['', Validators.required],
          addForms: ['', Validators.required],
          emailbody: ['']
        })
      }
    
      createtemplatelibraryheaderValueChange(value: string): void {
        // this.template.header = value;
      } 
    
      createtemplatelibraryheaderimageuploaddialog() {    
        this.createtemplatelibraryheaderupload.open();
      }
    
      remove(pbSupportDocumentId: any): void {
        const itemIndex = this.formsList.findIndex(form => form.pbSupportDocumentId === pbSupportDocumentId);
        if (itemIndex !== -1) {
          const currentValue: any[] = this.definedtemplate.controls['addForms'].value;
          this.definedtemplate.controls['addForms'].setValue(
            currentValue.filter((formId: any) => formId !== pbSupportDocumentId)
          );
          this.displayForms = this.displayForms.filter(form => form.pbSupportDocumentId !== pbSupportDocumentId);
        }
      }
      
    
      onChangeForms(code: any) {
        this.displayForms = [];
        this.displayForms = this.formsList.filter(item => code?.value.includes(item.pbSupportDocumentId));
      }


      onSubmit(){
        debugger
        console.log( this.definedtemplate.controls['emailbody'].value);
        if(this.definedtemplate.controls['emailbody'].value.includes('${')){
          this.placeholderErrorDialog = true;
    
     
          var split  = this.definedtemplate.controls['emailbody'].value.split("<p>");
         
          for(var i=0; i<split.length; i++){
            if(split[i].includes('${')){
              split[i] = "<p style='color:red'>"+split[i];
            }
            else{
              split[i] = "<p>"+split[i];
            }
          }      
     
          // this.definedtemplate.controls['emailbody'].value = split.join('');
          this.definedtemplate.controls['emailbody'].setValue(split.join(''));
    
    
          return false
        }
    
        if(this.definedtemplate.valid){
          const signatureData = {
            "emailBody": this.definedtemplate.controls['emailbody'].value,
            "emailCCList": this.definedtemplate.controls['ccEmailids'].value ? this.definedtemplate.controls['ccEmailids'].value : [],
            "emailSubject": this.definedtemplate.controls['subject'].value,
            "emailToList": this.definedtemplate.controls['toEmailids'].value,
            "signatureDocumentDTOList": this.displayForms,
            "taskId": this.primaryData.subTaskId,
            "taskStepId": this.primaryData.stepId,
            "type": this.returnForms == 'type3' ? 'DLVRSRVC' : 'SIGNUPLOADFORM',
            "signatureType": this.signatureType === 'Signature1' ? 'IMAGE' : 'MANUAL',
            "signatories": this.signatureInfo.filter(item => item.checked === true)
          };
     
          this.gcI140Service.postSendsignature(signatureData).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
            if (response && response.status==200) {
              this.toastr.success(response.message, 'Success');
              this.displayDialog = false;
              this.onLoadSignature();
              // this.getDocumentDetailsList();
              this.onReturnForms(this.returnForms);
            }
          });
        }
      }
    
      onChangeCourierStatus(){
        if(this.courierStatusForm.valid){
          this.gcI140Service.postCourier(this.courierStatusForm.controls['courierStatus'].value, this.selectedCourierArr).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
            if (response && response.status==200) {
              this.toastr.success(response.message, 'Success');
              this.displayCourier = false; 
              this.onReturnForms(this.returnForms);
            }
          });
        }
      }
    
      onClickCourier(val, id){
        this.displayCourier = true; 
        this.selectedCourierArr = [];
        if(id==1 && val){
          this.selectedCourierArr = [val];
        } else {
          this.selectedCourierArr = this.checkedList.map(item => item.id);
        }
      }
    
      onClickCloseCourier(){
        this.displayCourier = false;
      }
    
      toggleVisibility(event, item) {
        this.signatureInfo[item].checked = event.target.checked;
    
        this.signatureInfo.filter(x=>x.signatureAvalible).map(y=>{
          if(y.checked){
            this.currentSelect = true;
          }
        })
    
        this.currentSelect = this.signatureInfo.find(x=>x.signatureAvalible && x.checked);
    
        this.signatureInfo.filter(x=>!x.signatureAvalible).map(y=>{
          if(y.checked){
            this.currentSelect = false;
          }
        })
      } 
    
      toggleSignatoryVisibility(event, item) {
        this.selectedSignatory[item].checked = event.target.checked;
      } 
    
      onSignatureSubmit(){
        if(this.signatureInfo.find(item => item.checked === true) && this.checkedList.length!==0){
          const payload = {
            signatories: this.signatureInfo,
            signatureDocumentDTOList: this.checkedList,
            signatureNotificationDTO: this.signatureInfo,
            signatureType: "IMAGE",
            taskId: this.primaryData.subTaskId,
            taskStepId: this.primaryData.stepId,
            type: null,
            usedInImage: true
          }
          this.gcI140Service.postsignatureDetails(this.primaryData.subTaskId, payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
            if (response && response.status==200) {
              this.toastr.success(response.message, 'Success');
              // this.getDocumentDetailsList();
              this.onLoadSignature();
              this.onReturnForms(this.returnForms);
            }  
          });
        } else {
          CustomErrorToastComponent.showErrorToast(this.toastr, 'Please select the Signatories & forms from below section');
        }
      }
    
      // getDocumentDetailsList() {
      //   this.gcI140Service.getDocumentDetails(this.primaryData.stepId).pipe(takeUntil(this.observableSubscription$)).subscribe((response: ImagilityBaseResponse) => {
      //     if (response && response.data && response.data.signatureDocumentDTOList.length > 0) 
      //       {
      //         // this.dataSource = [];
      //         this.dataSource = response.data.signatureDocumentDTOList;
      //         // this.dataSource.map(item=>{
      //         //   item.isSelected = false;
      //         // });
      //       }
      //   });
      // } 
    
      onClickGenerateForm(pbSupportDocumentId){
        this.individualForm = [];
        if(pbSupportDocumentId){
          this.individualForm.push(this.listDocuments.find(item => pbSupportDocumentId == item.pbSupportDocumentId));
          this.postGenerateDoc(this.individualForm, 1);
        }
      }
      
      // postGenerateDoc(gcFormtype) { 
      //   const payload = {
      //     formType: gcFormtype,
      //   }
      //   this.gcI140Service.postFormType(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, gcFormtype, payload).subscribe(response => {
      //     if (response.status === 200 && response.data != null) {
      //       this.gcPDFSrc = response.data['fileLocation'] || '';
      //       if (this.gcPDFSrc != '') {
              
      //         this.toastr.success(response.message, "Success");// all done
      //       }
      //     }
      //   })
      // }

      postGenerateDoc(currentItem, data) {
        const apiCalls = []; // Array to hold all API call observables
        currentItem.forEach(immCategory => {
          if (immCategory.formCode === 'COVLTR' || immCategory.formCode === 'SUPLTR') {
            let tempTemplateId;
            tempTemplateId = immCategory.formCode === 'COVLTR' ? immCategory.petitionTemplateInfo?.coverLetterTemplateId : immCategory.petitionTemplateInfo?.supportLetterTemplateId;
            if (this.primaryData.caseType === 'I140') {

              apiCalls.push(
                this.gcI140Service.getPreview(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, immCategory.formCode, { templateId: tempTemplateId })
                  .pipe(mergeMap(() => this.generatePDF(immCategory.formCode, tempTemplateId)))
              ); 
            }
          } else {
            // Push formType API call into the API calls list
            const payload = { formType: immCategory.formCode };
            apiCalls.push(
              this.gcI140Service.postFormType(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, immCategory.formCode, payload)
            );
          }
        });
      
        // Execute API calls sequentially using concatMap
          if (apiCalls.length > 0) {
          from(apiCalls)
            .pipe(
              concatMap(apiCall => apiCall.pipe(delay(100))), // Ensures sequential execution
              takeLast(1) // Ensures we show success after all API calls complete
            )
            .subscribe({
              next: () => {
                this.toastr.success('Forms Generated Successfully!', "Success");
                this.getNotification(data);
              },
              error: err => {
                console.error('Error in API calls:', err);
              }
            });
        }
      }

      getNotification(data){
        if(data!==1){
          if(this.checkedList.filter(x=>x.id !== null).length!==0){
            this.gcI140Service.sendNotification(this.signatureDetailId, this.checkedList.filter(x=>x.id !== null).map(y=>y.id)).subscribe(res=>{
              if(res){
                this.getDocumentsList();
              }
            })
          } else {
            this.getDocumentsList();
          }
        } else {
          if(this.individualForm[0].id){
            this.gcI140Service.sendNotification(this.signatureDetailId, [this.individualForm[0].id]).subscribe(res=>{
              if(res){
                this.getDocumentsList();
              }
            })
          } else {
            this.getDocumentsList();
          }
        }
      }
      
      getDocumentsList(){
        this.checkedList = [];
        this.masterSelected = false;
        this.getDocumentDetails();
      }
      // postDependentGenerateDocObservable(formType, id, generateAll, relationshipCode) {
      //   const applicantList: string[] = [];
      
      //   if (generateAll === 'true' || (this.primaryData.visatype === 'ASYLUM' && this.primaryData.immigrationClassification !== 'ASYLRELATIVE' && this.dependentFormInfo.applicantList?.length > 0)) {
      //     const secondaryApplicants = this.dependentFormInfo.applicantList.filter(item => !item.primaryApplicant);
      //     applicantList.push(...secondaryApplicants.map(({ id }) => id));
      //   } else if (id && relationshipCode) {
      //     applicantList.push(id);
      //   }
      
      //   const payload = {
      //     applicantList,
      //     generateAll: generateAll === 'true'
      //   };
      
      //   return this.gcI140Service.postDependentFormType(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId, this.primaryData.subTaskId, formType, payload);
      // }
      
      generatePDF(formCode, tempTemplateId) {

        const pdfObservable = this.gcI140Service.generatePDF(this.dynamicDialogConfig.data.superTaskId, this.dynamicDialogConfig.data.i140CaseId, formCode, { templateId:  { templateId: tempTemplateId }})
      
        return pdfObservable.pipe(tap(() => console.log('PDF Generated:', formCode)));
      }
    
      // getDependentFormInfo() {
      //   this.gcI140Service.getDependentFormInfo(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId)
      //     .pipe(takeUntil(this.observableSubscription$))
      //     .subscribe((response: ImagilityBaseResponse) => {
      //       try {
      //         if (this.primaryData.getTaskType === 'I485' || response.data.generateFormFor) {
      //           this.dependentFormInfo = response.data;
      //         } else {
      //           this.dependentFormInfo = response.data;
      //         }
      //       } catch (error) {
      //         console.log("error outside", error)
      //       }
      //     });
      // } 
    
      toggleMenu(item: any, i: any, event: MouseEvent): void {
        event.stopPropagation(); // Prevent the click from bubbling up to the document
        this.currentItem = i;
        this.isMenuVisible = !this.isMenuVisible;
      }
    
      onUploadHandle(event, fubauto, pbSupportDocumentId, formCode) {
        debugger   
        const file: any = event.files[0];
        file.fileName = event.files[0].name;
    
        if (file.size / 1024 / 1024 > this.maxfileSizeInMB) {
          CustomErrorToastComponent.showErrorToast(this.toastr, `File size should be less than or equal to ${this.maxfileSizeInMB}MB`);
          fubauto.clear();
          return;
        }
    
        const payload = new FormData();
        payload.append('file', file, file.name);
        let formTypeValue;
        if(formCode=='I140' || formCode=='I130'){
          formTypeValue = formCode;
        } else { 
          formTypeValue = null;
        }
        this.gcI140Service.uploadDocument(pbSupportDocumentId, payload, this.signatureDetailId, formCode).pipe(takeUntil(this.observableSubscription$))
          .subscribe((response: any) => {
            this.toastr.success(response.message, 'Success');
            this.onReturnForms(this.returnForms); 
            fubauto.clear();
          });
      }
    
      download(file) {
        this.gcI140Service.downloadDocuments(environment.docs + file.substring(23), file.substring(23));
      }
}
